import {
  MODERN_AUTH_EXPERIMENT,
  type TreatmentsMap,
} from './experimentation';

export type AuthSystem = 'legacy' | 'modern';

/**
 * Resolves the single authentication system a browser session uses. Keeping
 * this separate from individual surfaces prevents a modern-treated visitor
 * from seeing a mix of legacy and OAuth2 authentication entry points.
 */
export function authSystemForTreatments(treatments: TreatmentsMap): AuthSystem {
  return treatments[MODERN_AUTH_EXPERIMENT]?.bucket.name === 'modern_auth' ? 'modern' : 'legacy';
}
